import { type LayoutNodeContentMap } from 'shop-ui/types/basic';

export const NodeContentManager = {
    getNodeContent(contentMap: LayoutNodeContentMap, id: string) {
        return contentMap[id] ?? '';
    },
};
